module.exports = __webpack_public_path__ + "img/dashboard-theft.08ef2dc3.svg";